import { Routes, Route, BrowserRouter } from 'react-router-dom';
import './App.css';

import NoIndex from './pages/main/NoIndex';
import Main from './pages/main/Main';
import Error404 from  './pages/error/NotFound'
function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Routes>      
          <Route path="/" element={<NoIndex/>} />          
          <Route path="/:isocode/:membership" element={<Main/>} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>      
    </div>
  );
}

export default App;
